import * as React from 'react';
import { hasValue } from '../../lib/utils';
import { StyledLabel } from './StyledElements';

const FieldDecorator = (props: FieldDecoratorProps) => {
	const { className, htmlFor, label, children, errorMessage, title, displayOptionalLabel } = props;
	return (
		<div className={`k-form-field${hasValue(className) ? ` ${className}` : ''}`} id={props.id ?? htmlFor}>
			{label && (
				<StyledLabel title={title ?? ''} htmlFor={htmlFor}>
					{label} {displayOptionalLabel && <span className="optional">- optional</span>}
				</StyledLabel>
			)}
			{children}
			{errorMessage && (
				<p className="error" title={errorMessage}>
					{errorMessage}
				</p>
			)}
		</div>
	);
};

interface FieldDecoratorProps {
	children: React.ReactNode;
	className?: string;
	label?: string;
	htmlFor?: string;
	errorMessage?: string;
	title?: string;
	displayOptionalLabel?: boolean;
	id?: string;
}

FieldDecorator.defaultProps = {
	className: null,
	label: null,
	htmlFor: null,
	errorMessage: null,
	title: null,
	displayOptionalLabel: false,
	id: null
};

export default FieldDecorator;
